<script setup>
import { storeToRefs } from "pinia";
import cChan from "@images/c-chan.png";
import Typed from "typed.js";

const onboarding = useOnboardingStore();
const { instruction } = storeToRefs(onboarding);
const typedTarget = ref(null);
let typedInstance = null;
let typingTimer, controllerFrame;
let previousBack;
const close = () => onboarding.closeInstruction();
function cleanup() {
  clearTimeout(typingTimer);
  cancelAnimationFrame(controllerFrame);
  typedInstance?.destroy();
  typedInstance = null;
  document.removeEventListener('keydown', onKey, true);
}
function onKey(event) {
  if (event.key === 'Escape') {
    event.preventDefault();
    event.stopImmediatePropagation();
    close();
  }
}
function pollController() {
  const back = [...(navigator.getGamepads?.() || [])].some(pad => pad?.connected && pad.buttons[1]?.pressed);
  if (previousBack === false && back) { close(); return; }
  previousBack = back;
  controllerFrame = requestAnimationFrame(pollController);
}
watch(() => instruction.value.show, visible => {
  cleanup();
  if (!visible) return;
  document.addEventListener('keydown', onKey, true);
  previousBack = undefined;
  controllerFrame = requestAnimationFrame(pollController);
  typingTimer = setTimeout(() => {
    if (!instruction.value.show || !typedTarget.value) return;
    typedInstance = new Typed(typedTarget.value, {
      strings: [instruction.value.text], typeSpeed: 20, backSpeed: 0,
      showCursor: true, cursorChar: '▋', smartBackspace: false,
    });
  }, 200);
}, { immediate: true });
onBeforeUnmount(cleanup);
</script>

<template>
  <v-dialog
    :model-value="instruction.show"
    class="!tw-z-[2411]"
    scrim="#000"
    opacity="0.5"
    width="440"
    @update:model-value="val => { if (!val) close(); }"
  >
    <v-card class="c-chan-dialog" color="rgba(0, 0, 0, 0.9)">
      <header class="c-chan-header">
        <strong>C-chan</strong>
        <v-btn aria-label="Close C-chan" @click="close">Close ×</v-btn>
      </header>
      <div class="c-chan-body" data-controller-scroll>
        <v-img :src="cChan" class="c-chan-avatar" eager />
        <v-card-text style="white-space: pre-line"><span ref="typedTarget" /></v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.c-chan-dialog { max-height: calc(100dvh - 48px); display: flex; flex-direction: column; border-radius: 16px !important; }
.c-chan-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 12px 16px; flex: 0 0 auto; }
.c-chan-body { overflow-y: auto; min-height: 0; }
.c-chan-avatar { width: 220px; height: min(220px, 26dvh); max-width: 80%; margin: 0 auto; }
</style>
